import { PureComponent } from 'react';
// @ts-expect-error untyped module
import UIModalIFrame from 'ui-addon-iframeable/host/UIModalIFrame';
import { getIframeSrc } from 'quotes-modal-lib/utils/urls';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import { MSG_TYPE_FLOW_START, MSG_TYPE_HIDE_MODAL, MSG_TYPE_MODAL_HIDDEN, MSG_TYPE_ADD_ALERT } from 'quotes-modal-lib/constants/Messages';
import { jsx as _jsx } from "react/jsx-runtime";
class QuotesIFrameModal extends PureComponent {
  constructor(props) {
    super(props);
    this.handleOnReady = hostContext => {
      this.setState({
        hostContext
      }, () => {
        if (this.state.openedBeforeSync) {
          const {
            dealId,
            templateId,
            quoteId,
            flowType,
            embedSource
          } = this.props;
          this.sendFlowStartMessageToIFrame({
            dealId,
            templateId,
            quoteId,
            flowType,
            embedSource
          });
          this.setState({
            openedBeforeSync: false
          });
        }
      });
    };
    this.registerFlowStartMessageAfterSync = () => this.setState({
      openedBeforeSync: true
    });
    this.sendFlowStartMessageToIFrame = ({
      dealId,
      templateId,
      quoteId,
      flowType,
      embedSource
    }) => {
      window.onpopstate = this.handleCloseModal;
      if (this.state.hostContext) {
        this.state.hostContext.sendMessage(MSG_TYPE_FLOW_START, {
          dealId,
          templateId,
          quoteId,
          flowType,
          embedSource
        });
      }
    };
    this.sendModalHiddenMessageToIframe = () => {
      if (this.state.hostContext) {
        this.state.hostContext.sendMessage(MSG_TYPE_MODAL_HIDDEN);
      }
    };
    this.handleError = error => {
      console.error(error);
      this.handleCloseModal();
      if (this.props.onError) {
        this.props.onError();
      }
    };
    this.handleMessage = message => {
      const {
        payload: {
          type,
          alertProps
        }
      } = message;
      if (type === MSG_TYPE_HIDE_MODAL) {
        this.handleCloseModal();
      }
      if (type === MSG_TYPE_ADD_ALERT) {
        FloatingAlertStore.addAlert(alertProps);
      }
    };
    this.handleCloseModal = () => {
      window.onpopstate = null;
      if (this.props.onClose) {
        this.props.onClose();
      }
    };
    this.state = {
      hostContext: null,
      openedBeforeSync: false
    };
  }
  componentDidUpdate(prevProps) {
    // when show is false and becomes true, time to make the prerendered modal visible
    if (!prevProps.show && this.props.show) {
      // if the modal is opened before sync with iframe, wait for sync before starting the flow
      if (!this.state.hostContext) {
        this.registerFlowStartMessageAfterSync();
      } else {
        this.sendFlowStartMessageToIFrame(this.props);
      }
    }
    if (prevProps.show && !this.props.show) {
      this.sendModalHiddenMessageToIframe();
    }
  }
  render() {
    const {
      show
    } = this.props;
    const {
      openedBeforeSync
    } = this.state;
    return /*#__PURE__*/_jsx(UIModalIFrame, {
      appName: "quotes-admin",
      iframePassthruProps: {
        'data-test-id': `quotes-admin-iframe-${show ? 'open' : 'closed'}`,
        name: 'quotes-admin-iframe',
        id: 'quotes-admin-iframe'
      }
      // the wizard will not load at all if the sync times out, so using a massive timeout to be safe.
      ,
      initTimeout: 60000,
      preload: true,
      show: show,
      use: "fullscreen",
      width: "100%",
      height: "100%",
      src: getIframeSrc(),
      showLoadingIndicator: openedBeforeSync,
      onInitError: this.handleError,
      onReady: this.handleOnReady,
      onReadyError: this.handleError,
      onMessage: this.handleMessage,
      onClose: this.handleCloseModal
    });
  }
}
export default QuotesIFrameModal;